var _defs, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogov5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x2: 512,
    y1: 512,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e7e7e7",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 512,
    x2: 0,
    y2: 512,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff0909",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#800000",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x2: 512,
    y1: 512,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#800000",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff0101",
    offset: 1
  })))), /*#__PURE__*/React.createElement("g", {
    display: "none",
    fill: "url(#a)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512,
    display: "inline",
    fill: "#fff",
    stopColor: "#000000",
    style: {
      InkscapeStroke: "none",
      fontVariationSettings: "normal"
    }
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 10,
    style: {
      mixBlendMode: "normal"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m200 20v150l200 120v210l-80-48.745v-131.26l-200-120v-132z",
    display: "inline",
    fill: "#df2020"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m320 20 80 48v132l-50 30-66.25-38.25 36.25-21.75z",
    display: "inline"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m120 500 80-48v-132l36.25-21.75-66.25-38.25-50 30z",
    display: "inline"
  }))), /*#__PURE__*/React.createElement("g", {
    display: "none",
    strokeLinejoin: "round",
    strokeWidth: 10,
    style: {
      mixBlendMode: "darken"
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m200 20v150l200 120v210l-80-48.745v-131.26l-200-120v-132z",
    display: "inline",
    fill: "#3f3f3f",
    stroke: "#3f3f3f"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m320 20 80 48v132l-50 30-66.25-38.25 36.25-21.75z",
    display: "inline",
    fill: "#404040",
    stroke: "#404040"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m120 500 80-48v-132l36.25-21.75-66.25-38.25-50 30z",
    display: "inline",
    fill: "#404040",
    stroke: "#414141"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", {
    fill: "url(#c)",
    stopColor: "#000000",
    stroke: "url(#b)",
    strokeLinejoin: "round",
    strokeWidth: 10,
    style: {
      fontVariationSettings: "normal"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m320 20 80 48v132l-50 30-66.25-38.25 36.25-21.75z",
    stopColor: "#000000",
    style: {
      fontVariationSettings: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m200 20v150l200 120v210l-80-48.745v-131.26l-200-120v-132z",
    stopColor: "#000000",
    style: {
      fontVariationSettings: "normal",
      mixBlendMode: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m120 500 80-48v-132l36.25-21.75-66.25-38.25-50 30z",
    stopColor: "#000000",
    style: {
      fontVariationSettings: "normal",
      mixBlendMode: "normal"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogov5);
export default __webpack_public_path__ + "static/media/Logov5.9f71d7a4de73514b697de6477daf274c.svg";
export { ForwardRef as ReactComponent };